import { render, staticRenderFns } from "./MyStatsPopup.vue?vue&type=template&id=50843a44&scoped=true"
import script from "./MyStatsPopup.vue?vue&type=script&lang=js"
export * from "./MyStatsPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50843a44",
  null
  
)

export default component.exports